var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: [`validationText ${_vm.addClass}`, {
      'alert': _vm.status
    }]
  }, [_vm._t("default"), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.status,
      expression: "status"
    }],
    staticClass: "alertText"
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }